export const COMMON_API = (baseURL) => {
  return {
    timezonesEndpoint: `${baseURL}/dictionaries/timezones`,
    avatarEndpoint: `${baseURL}/avatar`,
    profileEndpoint: `${baseURL}/v1/profile`,
    searchEndpoint: `${baseURL}/v1/admin/search-history`,
    annoncesEndpoint: `${baseURL}/v1/admin/products`,
    usersEndpoint: `${baseURL}/v1/admin/users`,
    subscriptionEndpoint: `${baseURL}/v1/subscription`,
    categoriesEndpoint: `${baseURL}/v1/categories`,
  }
}
